import { Pipe, PipeTransform } from '@angular/core';
import { MetaTagsService } from 'src/app/services/meta-tags.service';

@Pipe({
  name: 'facebook'
})
export class FacebookPipe implements PipeTransform {

  constructor(
    private MetaTagsService: MetaTagsService
  ) { }

  transform(link: string, metaData: any): string {
    const pageMetaData = this.MetaTagsService.getPageMetaTags();
    return encodeURI(`https://www.facebook.com/sharer/sharer.php?u=${pageMetaData?.url}&picture=${pageMetaData?.img}&t=${pageMetaData?.title}&q=${pageMetaData?.description}`);
  }

}
